import { exists, SystemCodeArea, SystemCodeAddress } from '@/api'
import dayjs from 'dayjs'

export interface BatchStatisticsConditionListItem {
  lendDateFrom: string
  lendDateTo: string
  lendTitle: string
  userPersonaleEnabled: boolean
  userGroupEnabled: boolean
  lendFormat: string
  rdoInterlibraryLoan: string
  rdoSetNumber: string
  lendType: string[]
  lendBranchCodeFrom: string
  lendBranchCodeTo: string
  placeCodeFrom: string
  placeCodeTo: string
  areaCodeFrom: SystemCodeArea
  areaCodeTo: SystemCodeArea
  addressCodeForm: SystemCodeAddress
  addressCodeTo: SystemCodeAddress
  userIdFrom: string
  userIdTo: string
  interlibraryLoanCodeFrom: string
  interlibraryLoanCodeTo: string
  yearAgeEnabled: boolean
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  numberEnabled: boolean
  numberOfPeopleEnabled: boolean
  numberOfPeopleActualEnabled: boolean
  lendMemo: string
  isOutputFull: boolean
  batchType: string
}

export function BatchStatisticsConditionListItemFromJSON(
  json: any
): BatchStatisticsConditionListItem {
  const resp = JSON.parse(json)

  return {
    lendDateFrom: exists(resp, 'lend_date_from')
      ? resp.lend_date_from
      : dayjs()
          .add(-1, 'month')
          .format('YYYYMMDD'),
    lendDateTo: exists(resp, 'lend_date_to')
      ? resp.lend_date_to
      : dayjs().format('YYYYMMDD'),
    lendTitle: exists(resp, 'title') ? resp.title : '',
    userPersonaleEnabled: exists(resp, 'user_personal_enabled')
      ? resp.user_personal_enabled
      : false,
    userGroupEnabled: exists(resp, 'user_group_enabled')
      ? resp.user_group_enabled
      : false,
    lendFormat: exists(resp, 'lend_format') ? resp.lend_format : '1',
    rdoInterlibraryLoan: exists(resp, 'rdo_interlibrary_loan')
      ? resp.rdo_interlibrary_loan
      : '1',
    rdoSetNumber: exists(resp, 'rdo_set_number') ? resp.rdo_set_number : '1',
    lendType: exists(resp, 'lend_type') ? resp.lend_type : ['0', '0', '0', '0'],
    lendBranchCodeFrom: exists(resp, 'lend_branch_code_from')
      ? resp.lend_branch_code_from
      : '',
    lendBranchCodeTo: exists(resp, 'lend_branch_code_to')
      ? resp.lend_branch_code_to
      : '',
    placeCodeFrom: exists(resp, 'place_code_from') ? resp.place_code_from : '',
    placeCodeTo: exists(resp, 'place_code_to') ? resp.place_code_to : '',
    areaCodeFrom:
      exists(resp, 'area_code_from') && resp.area_code_from !== ''
        ? resp.area_code_from
        : null,
    areaCodeTo:
      exists(resp, 'area_code_to') && resp.area_code_to !== ''
        ? resp.area_code_to
        : null,
    addressCodeForm:
      exists(resp, 'address_code_from') && resp.address_code_from !== ''
        ? resp.address_code_from
        : null,
    addressCodeTo:
      exists(resp, 'address_code_to') && resp.address_code_to !== ''
        ? resp.address_code_to
        : null,
    userIdFrom: exists(resp, 'user_id_from') ? resp.user_id_from : '',
    userIdTo: exists(resp, 'user_id_to') ? resp.user_id_to : '',
    interlibraryLoanCodeFrom: exists(resp, 'interlibrary_loan_code_from')
      ? resp.interlibrary_loan_code_from
      : '',
    interlibraryLoanCodeTo: exists(resp, 'interlibrary_loan_code_to')
      ? resp.interlibrary_loan_code_to
      : '',
    yearAgeEnabled: exists(resp, 'year_age_enabled')
      ? resp.year_age_enabled
      : false,
    xItem: resp.x_item,
    yItem1: resp.y_item1,
    yCheck1: exists(resp, 'y_check1') ? resp.y_check1 : [false, false],
    yItem2: exists(resp, 'y_item2') ? resp.y_item2 : '',
    yCheck2: exists(resp, 'y_check2') ? resp.y_check2 : [false, false],
    yItem3: exists(resp, 'y_item2') ? resp.y_item3 : '',
    yCheck3: exists(resp, 'y_check3') ? resp.y_check3 : [false, false],
    yItem4: exists(resp, 'y_item2') ? resp.y_item4 : '',
    yCheck4: exists(resp, 'y_check4') ? resp.y_check4 : [false, false],
    numberEnabled: exists(resp, 'number_enabled') ? resp.number_enabled : false,
    numberOfPeopleEnabled: exists(resp, 'number_of_people_enabled')
      ? resp.number_of_people_enabled
      : false,
    numberOfPeopleActualEnabled: exists(resp, 'number_of_people_actual_enabled')
      ? resp.number_of_people_actual_enabled
      : false,
    isOutputFull: exists(resp, 'is_output_full') ? resp.is_output_full : false,
    lendMemo: resp.memo,
    batchType: resp.batch_type
  }
}
